import { css } from "styled-components";
import token from "styled-token";
import { spaceMixin } from "../spaceMixin";
import { spacingMixin } from "../spacingMixin";
import { tableResetMixin } from "../tableResetMixin";
/** @class DatePickerMixin */

/** @method */

export var DatePickerMixin = function DatePickerMixin(props) {
  return token({
    backgroundColor: "colors.white",
    height: "sizes.heights.sm",
    borderColor: "colors.borderLight"
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
        height = _ref.height,
        borderColor = _ref.borderColor;
    return css(["background:", ";table{", " margin-top:", ";}table td,table th{height:40px;padding:", ";box-sizing:border-box;}table thead tr th{height:", "px;line-height:", "px;vertical-align:top;border-bottom:1px solid ", ";padding-bottom:", ";padding-top:0;text-align:center;}table tbody tr:first-child td{padding-top:", ";}", ""], backgroundColor, tableResetMixin(props), spaceMixin(0.5)(props), spaceMixin(0.5)(props), spaceMixin("xs", function (space) {
      return space.value + height + 1;
    })(props), height, borderColor, spaceMixin("xs")(props), spaceMixin("xs")(props), spacingMixin(props));
  })(props);
};